import React from 'react';

import UserInvite from "components/Enterprise/UserManagement/UserInvite/";
import UserList from "components/Enterprise/UserManagement/UserList/";

function UserManagement({
  companyId,
  sudoSiteId,
  siteName,
}) {

  return (
    <div style={{maxHeight: "60vh", overflowY: "scroll"}}>
      <div>
        <UserInvite
          origin="Companies"
          companyId={companyId}
          sudoSiteId={sudoSiteId}
          siteName={siteName}
        />
      </div>
      <div>
        <UserList
          origin="Companies"
          companyId={companyId}
          sudoSiteId={sudoSiteId}
          siteName={siteName}
        />
      </div>
    </div>
  )
}

export default UserManagement;